import DebugViewModelT from '@/ViewModels/Views/DebugViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class DebugViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private DebugViewModel: any;
    private DebugView: any;
    constructor(params: any) {
        super(params);
        this.DebugViewModel = ComponentManager.getViewModel<typeof DebugViewModelT>('DebugViewModel');
        this.DebugView = ComponentManager.getView('DebugView');
    }
    public getRegion(): string {
        return 'Debug';
    }
    public getView(): any {
        localStorage.clear();
        if (this.viewModel == null) {
            this.viewModel = new this.DebugViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.DebugView(this.viewModel, this.createRootElement('Debug'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
    public getNecessaryRedirect(): any {
        return false;
    }
}

ComponentManager.setFactory('Debug', DebugViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');